import { render, staticRenderFns } from "./stepper-investigation-details.vue?vue&type=template&id=7bab8451&"
import script from "./stepper-investigation-details.vue?vue&type=script&lang=js&"
export * from "./stepper-investigation-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports